import { isUserLoggedIn, logIn } from '../utils/auth';
import Button from './Button';

type Props = {
  children: React.ReactNode;
  text?: string;
};

const AuthGuard = ({ children, text = 'Prijavi se kako bi video svoj profil' }: Props) => {
  const isLoggedIn = isUserLoggedIn();

  const handleLogin = () => {
    logIn();
  };

  return (
    <div>
      {!isLoggedIn && (
        <div className="text-center mt-4">
          {text}
          <Button className="mt-4 ms-0 mx-auto" onClick={handleLogin}>
            Prijavi se
          </Button>
        </div>
      )}

      {isLoggedIn && <>{children}</>}
    </div>
  );
};

export default AuthGuard;
